import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../SliderAnimation/SliderAnimation.css';
import cx from 'classnames';
import { graphql, compose, gql } from 'react-apollo';

// Components
import DetailSearchForm from '../DetailSearchForm/DetailSearchForm';
import SliderAnimation from '../SliderAnimation/SliderAnimation';

// Graphql
import getHomeBanner from '../../../routes/home/getHomeBanner.graphql';
class Layout3 extends React.Component {
    constructor(props) {
        super(props);
        this.scrollTop = this.scrollTop.bind(this);
    }

    scrollTop() {
        window.scrollTo({
            top: screen.height,
            behavior: 'smooth'
        })
    }

    render() {
        const { getBannerData, getHomeBannerData } = this.props;

        let data, loading, title, content, homeBannerImages;
        data = getBannerData.getBanner;
        loading = getBannerData.loading;
        homeBannerImages = getHomeBannerData && getHomeBannerData.getHomeBanner;

        if (data) {
            title = getBannerData.getBanner.title;
            content = getBannerData.getBanner.content
        }

        return (
            <div>
                <div className={cx('homeBannerSlider')}>
                    <div className={cx(s.homePosition, 'homePosition')}>
                        <div className={s.homeCarsoual}>
                            <SliderAnimation homeBannerImages={homeBannerImages} />
                        </div>
                        {
                            !loading && data ? <div className={cx(s.container, s.FormBookWrap)}>
                                <div className={s.FormBookWrap}>
                                    <div className={s.BookWrap}>
                                        <h1><span>{title}</span>
                                            {' '} {content}
                                        </h1>
                                        <DetailSearchForm />
                                    </div>
                                </div>
                            </div> : <div />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    withStyles(s),
    graphql(gql`
    query getBanner{
      getBanner {
        id
        title
        content
      }
    }
  `, {
        name: 'getBannerData',
        options: {
            ssr: true
        }
    }),
    graphql(getHomeBanner, {
        name: 'getHomeBannerData',
        options: {
          ssr: true
        },
      }),
)(Layout3);



// WEBPACK FOOTER //
// src/components/Home/Layout3/Layout3.js